/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";


function useGraphData({
    metricData,
    forecast_wallthickness,
    resetWTIndexes,
    isMeasuredWallThicknessChecked,
    predWTData,
    faultySensorData,
    missingFeature,
    units,
    loading,
    sensorData
}) {
    console.log(faultySensorData)
    const [graphData, setGraphData] = useState(null);
    useEffect(() => {
        let updatedGraphData = null;

        if (metricData != null) {
            if (forecast_wallthickness != null) {
                updatedGraphData = [...metricData, ...forecast_wallthickness];
            } else {
                updatedGraphData = metricData;
            }
        } else if (!loading && forecast_wallthickness != null) {
            updatedGraphData = forecast_wallthickness;
        }

        if (predWTData) {
            updatedGraphData = updatedGraphData ? [...updatedGraphData, predWTData] : [predWTData];
        }

        if (
            resetWTIndexes?.length > 0 &&
            updatedGraphData?.length > 0 &&
            updatedGraphData?.filter((obj) => obj.name === "Predicted wall thickness").length > 0
        ) {
            const pwtGraphdata = updatedGraphData?.map((obj) => {
                if (obj.name === "Predicted wall thickness") {
                    resetWTIndexes.forEach((ele) => {
                        obj.y[ele] = null;
                    });
                }
                return obj;
            });
            updatedGraphData = [...pwtGraphdata];
        }

        // Set Marker color for measured wall thickness in case of faulty sensors
        if (
            faultySensorData?.length > 0 &&
            updatedGraphData?.length > 0 &&
            updatedGraphData?.filter((obj) => obj.name === "Measured wall thickness").length > 0
        ) {
            const mwtGraphdata = updatedGraphData?.map((obj) => {
                const textAry = [];
                if (obj.name === "Measured wall thickness") {
                    const colr = faultySensorData?.map((ele, index) => {
                        if (ele) {
                            textAry.push("Faulty sensor data excluded from prediction and rating");
                            return "orange";
                        } else {
                            textAry.push("");
                            return "#0097A9";
                        }
                    });
                    obj.hovertemplate = `%{y} ${units ? "[inch]" : "[mm]"} <br> %{text}`;
                    obj.marker.color = colr;
                    obj.text = [...textAry];
                    obj.marker.size = "5";
                }
                return obj;
            });
            updatedGraphData = [...mwtGraphdata];
        }

        if (updatedGraphData?.length > 0) {
            const measuredMetricData = updatedGraphData.find(
                (metric) => metric.name === "Measured wall thickness"
            )?.y;
            const predictedMetricData = updatedGraphData.find(
                (metric) => metric.name === "Predicted wall thickness"
            )?.y;
            if (measuredMetricData && predictedMetricData) {
                // count the number of non null values in both arrays
                const measuredCount = measuredMetricData.filter((val) => val !== null).length;
                const predictedCount = predictedMetricData.filter((val) => val !== null).length;

                // if measured count less than predicted than increase marker size of measured wall thickness
                if (measuredCount < predictedCount && !sensorData?.isRealSensor) {
                    updatedGraphData = updatedGraphData.map((obj) => {
                        if (obj.name === "Predicted wall thickness") {
                            obj.marker.size = "4";
                        }
                        if (obj.name === "Measured wall thickness") {
                            obj.marker.size = "10";
                            obj.marker.symbol = "diamond";
                        }
                        return obj;
                    });
                }

                const isMeasuredMetricData = measuredMetricData.every((val) => val === null);
                const isPredictedMetricData = predictedMetricData.every((val) => val === null);
                if (isMeasuredMetricData && isPredictedMetricData) {
                    toast.error(
                        "The Prediction results may not have been displayed in the UI for this sensor because there is no last measurement data available to initiate the prediction",
                        {
                            toastId: "noData",
                            style: {
                                textAlign: "center",
                            },
                        }
                    );
                }
            }
        }

        if (
            updatedGraphData?.length > 0 &&
            updatedGraphData?.filter((obj) => obj.name === "Predicted wall thickness").length > 0 &&
            updatedGraphData?.filter((obj) => obj.name === "Missing features").length > 0 &&
            missingFeature?.data?.length > 0
        ) {
            const msgFGraphdata = updatedGraphData?.map((obj) => {
                const textAry = [];
                if (obj.name === "Predicted wall thickness") {
                    const colr = missingFeature?.data?.map((ele, index) => {
                        if (ele !== null) {
                            if (ele >= 0 && ele < 33.33) {
                                if (missingFeature?.missing[index] === 100) {
                                    textAry.push("with limited data");
                                    return 80;
                                }
                                textAry.push("");
                                return 20;
                            } else if (ele >= 33.33 && ele < 66.66) {
                                textAry.push("with limited data");
                                return 60;
                            } else {
                                textAry.push("with limited data");
                                return 80;
                            }
                        } else {
                            return null;
                        }
                    });
                    colr.push(90);
                    obj.marker.color = colr;
                    obj.marker.colorscale = "Greys";
                    obj.marker.size = "5";
                    obj.text = [...textAry];
                    obj.hovertemplate = `%{y} ${units ? "[inch]" : "[mm]"} <br> %{text}`;
                }
                return obj;
            });
            updatedGraphData = [...msgFGraphdata];
        }

        setGraphData(updatedGraphData);
    }, [
        metricData,
        forecast_wallthickness,
        resetWTIndexes,
        isMeasuredWallThicknessChecked,
        predWTData,
        faultySensorData,
        missingFeature,
        units,
        loading,
    ]);

    return { graphData }
}

export default useGraphData;